import {
  getConfirmedAt,
  getClientPhone,
  getClientData,
  getClientAuthToken,
  getClientUnconfirmedPhone,
  getShowLogOutPopup,
  getIsLoggedIn,
} from 'src/store/client/selectors';
import { getIsMobile, getIsWhitelabel } from 'src/store/view/selectors';
import { confirmClientAction } from 'checkout/store/actions/order';
import {
  logInAction,
  logOutAction,
  setClientInfo,
  signUpAction,
  setClientConfirmPhone,
} from 'src/store/client/actions';
import { connect } from 'react-redux';
import Client from './Client';

const mapStateToProps = (state) => ({
  clientData: getClientData(state),
  isConfirmedEmail: getConfirmedAt(state),
  isLoggedIn: getIsLoggedIn(state),
  isWhitelabel: getIsWhitelabel(state),
  isMobile: getIsMobile(state),
  clientAuthToken: getClientAuthToken(state),
  unconfirmedPhone: getClientUnconfirmedPhone(state),
  clientPhone: getClientPhone(state),
  isShowLogOutPopup: getShowLogOutPopup(state),
});

const mapDispatchToProps = (dispatch) => ({
  setClientInfo: (data) => dispatch(setClientInfo(data)),
  confirmClient: (data) => dispatch(confirmClientAction(data)),
  setConfirmedPhone: (data) => dispatch(setClientConfirmPhone(data)),
  logIn: (data) => dispatch(logInAction(data)),
  signUp: (data) => dispatch(signUpAction(data)),
  logOut: () => dispatch(logOutAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Client);
